/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * Live Class student API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { customInstance } from "../../../api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const create = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/api/v1/students/sync`, method: "POST", signal },
    options,
  );
};

export const getCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof create>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof create>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["create"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof create>>,
    void
  > = () => {
    return create(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof create>>
>;

export type CreateMutationError = unknown;

export const useCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof create>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof create>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const apiParam = (
  classId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/api/v1/students/classworks/${classId}`, method: "GET", signal },
    options,
  );
};

export const getApiParamQueryKey = (classId?: string) => {
  return [`/api/v1/students/classworks/${classId}`] as const;
};

export const getApiParamQueryOptions = <
  TData = Awaited<ReturnType<typeof apiParam>>,
  TError = unknown,
>(
  classId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiParam>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiParamQueryKey(classId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiParam>>> = ({
    signal,
  }) => apiParam(classId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!classId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof apiParam>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ApiParamQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiParam>>
>;
export type ApiParamQueryError = unknown;

export function useApiParam<
  TData = Awaited<ReturnType<typeof apiParam>>,
  TError = unknown,
>(
  classId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiParam>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiParam>>,
          TError,
          Awaited<ReturnType<typeof apiParam>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useApiParam<
  TData = Awaited<ReturnType<typeof apiParam>>,
  TError = unknown,
>(
  classId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiParam>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiParam>>,
          TError,
          Awaited<ReturnType<typeof apiParam>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useApiParam<
  TData = Awaited<ReturnType<typeof apiParam>>,
  TError = unknown,
>(
  classId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiParam>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useApiParam<
  TData = Awaited<ReturnType<typeof apiParam>>,
  TError = unknown,
>(
  classId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiParam>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getApiParamQueryOptions(classId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiQuery = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/api/v1/students/trigger-event/event`, method: "GET", signal },
    options,
  );
};

export const getApiQueryQueryKey = () => {
  return [`/api/v1/students/trigger-event/event`] as const;
};

export const getApiQueryQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQuery>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof apiQuery>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiQueryQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQuery>>> = ({
    signal,
  }) => apiQuery(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiQuery>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ApiQueryQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQuery>>
>;
export type ApiQueryQueryError = unknown;

export function useApiQuery<
  TData = Awaited<ReturnType<typeof apiQuery>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQuery>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQuery>>,
          TError,
          Awaited<ReturnType<typeof apiQuery>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useApiQuery<
  TData = Awaited<ReturnType<typeof apiQuery>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQuery>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQuery>>,
          TError,
          Awaited<ReturnType<typeof apiQuery>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useApiQuery<
  TData = Awaited<ReturnType<typeof apiQuery>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQuery>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useApiQuery<
  TData = Awaited<ReturnType<typeof apiQuery>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQuery>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getApiQueryQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const saveCourseBatchPreferences = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/v1/students/course-batch-preferences`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getSaveCourseBatchPreferencesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveCourseBatchPreferences>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveCourseBatchPreferences>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["saveCourseBatchPreferences"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveCourseBatchPreferences>>,
    void
  > = () => {
    return saveCourseBatchPreferences(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveCourseBatchPreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveCourseBatchPreferences>>
>;

export type SaveCourseBatchPreferencesMutationError = unknown;

export const useSaveCourseBatchPreferences = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof saveCourseBatchPreferences>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof saveCourseBatchPreferences>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getSaveCourseBatchPreferencesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getCourseBatchPreferencesWithStatus = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/v1/students/get/course-preferences-with-status`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getGetCourseBatchPreferencesWithStatusMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getCourseBatchPreferencesWithStatus>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getCourseBatchPreferencesWithStatus>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["getCourseBatchPreferencesWithStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getCourseBatchPreferencesWithStatus>>,
    void
  > = () => {
    return getCourseBatchPreferencesWithStatus(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetCourseBatchPreferencesWithStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof getCourseBatchPreferencesWithStatus>>
>;

export type GetCourseBatchPreferencesWithStatusMutationError = unknown;

export const useGetCourseBatchPreferencesWithStatus = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getCourseBatchPreferencesWithStatus>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getCourseBatchPreferencesWithStatus>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getGetCourseBatchPreferencesWithStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getRecentRewatch = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/api/v1/students/get/recent-rewatches`, method: "POST", signal },
    options,
  );
};

export const getGetRecentRewatchMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getRecentRewatch>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getRecentRewatch>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["getRecentRewatch"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getRecentRewatch>>,
    void
  > = () => {
    return getRecentRewatch(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetRecentRewatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof getRecentRewatch>>
>;

export type GetRecentRewatchMutationError = unknown;

export const useGetRecentRewatch = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getRecentRewatch>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getRecentRewatch>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getGetRecentRewatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getClassAssignments = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/api/v2/students/get/class-assignments`, method: "POST", signal },
    options,
  );
};

export const getGetClassAssignmentsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getClassAssignments>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getClassAssignments>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["getClassAssignments"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getClassAssignments>>,
    void
  > = () => {
    return getClassAssignments(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetClassAssignmentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getClassAssignments>>
>;

export type GetClassAssignmentsMutationError = unknown;

export const useGetClassAssignments = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getClassAssignments>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getClassAssignments>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getGetClassAssignmentsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const myUpcomingClasses = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/api/v1/students/get/my-upcoming-classes`, method: "POST", signal },
    options,
  );
};

export const getMyUpcomingClassesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof myUpcomingClasses>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof myUpcomingClasses>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["myUpcomingClasses"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof myUpcomingClasses>>,
    void
  > = () => {
    return myUpcomingClasses(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MyUpcomingClassesMutationResult = NonNullable<
  Awaited<ReturnType<typeof myUpcomingClasses>>
>;

export type MyUpcomingClassesMutationError = unknown;

export const useMyUpcomingClasses = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof myUpcomingClasses>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof myUpcomingClasses>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getMyUpcomingClassesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const myPastClasses = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/api/v1/students/get/my-past-classes`, method: "POST", signal },
    options,
  );
};

export const getMyPastClassesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof myPastClasses>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof myPastClasses>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["myPastClasses"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof myPastClasses>>,
    void
  > = () => {
    return myPastClasses(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MyPastClassesMutationResult = NonNullable<
  Awaited<ReturnType<typeof myPastClasses>>
>;

export type MyPastClassesMutationError = unknown;

export const useMyPastClasses = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof myPastClasses>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof myPastClasses>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getMyPastClassesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const apiBody = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/api/v2/students/weeks/class`, method: "POST", signal },
    options,
  );
};

export const getApiBodyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiBody>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiBody>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["apiBody"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiBody>>,
    void
  > = () => {
    return apiBody(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiBodyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiBody>>
>;

export type ApiBodyMutationError = unknown;

export const useApiBody = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof apiBody>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof apiBody>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getApiBodyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const courseUpcomingClasses = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/v2/students/program/upcoming-classes`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getCourseUpcomingClassesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseUpcomingClasses>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseUpcomingClasses>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["courseUpcomingClasses"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseUpcomingClasses>>,
    void
  > = () => {
    return courseUpcomingClasses(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseUpcomingClassesMutationResult = NonNullable<
  Awaited<ReturnType<typeof courseUpcomingClasses>>
>;

export type CourseUpcomingClassesMutationError = unknown;

export const useCourseUpcomingClasses = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof courseUpcomingClasses>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof courseUpcomingClasses>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getCourseUpcomingClassesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const _public = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/api/v1/students/program/get/all-classes`, method: "POST", signal },
    options,
  );
};

export const getPublicMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof _public>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof _public>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["_public"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof _public>>,
    void
  > = () => {
    return _public(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type _PublicMutationResult = NonNullable<
  Awaited<ReturnType<typeof _public>>
>;

export type _PublicMutationError = unknown;

export const usePublic = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof _public>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof _public>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPublicMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const apiOperation = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/api/v1/students/get/program_ids`, method: "POST", signal },
    options,
  );
};

export const getApiOperationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOperation>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiOperation>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["apiOperation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOperation>>,
    void
  > = () => {
    return apiOperation(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiOperationMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiOperation>>
>;

export type ApiOperationMutationError = unknown;

export const useApiOperation = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof apiOperation>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof apiOperation>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getApiOperationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getStudentToDoClasses = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/api/v1/students/get/student-to-do`, method: "POST", signal },
    options,
  );
};

export const getGetStudentToDoClassesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getStudentToDoClasses>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getStudentToDoClasses>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["getStudentToDoClasses"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getStudentToDoClasses>>,
    void
  > = () => {
    return getStudentToDoClasses(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetStudentToDoClassesMutationResult = NonNullable<
  Awaited<ReturnType<typeof getStudentToDoClasses>>
>;

export type GetStudentToDoClassesMutationError = unknown;

export const useGetStudentToDoClasses = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getStudentToDoClasses>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getStudentToDoClasses>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getGetStudentToDoClassesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getSubjectData = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/api/v1/students/get/program/subjects`, method: "POST", signal },
    options,
  );
};

export const getGetSubjectDataMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getSubjectData>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getSubjectData>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["getSubjectData"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getSubjectData>>,
    void
  > = () => {
    return getSubjectData(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetSubjectDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof getSubjectData>>
>;

export type GetSubjectDataMutationError = unknown;

export const useGetSubjectData = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getSubjectData>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getSubjectData>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getGetSubjectDataMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getProgramData = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/api/v2/students/get/program/report`, method: "POST", signal },
    options,
  );
};

export const getGetProgramDataMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getProgramData>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getProgramData>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["getProgramData"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getProgramData>>,
    void
  > = () => {
    return getProgramData(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetProgramDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof getProgramData>>
>;

export type GetProgramDataMutationError = unknown;

export const useGetProgramData = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getProgramData>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getProgramData>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getGetProgramDataMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getProgramSubjectFilter = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/v2/students/get/program-subject-filters`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getGetProgramSubjectFilterMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getProgramSubjectFilter>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getProgramSubjectFilter>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["getProgramSubjectFilter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getProgramSubjectFilter>>,
    void
  > = () => {
    return getProgramSubjectFilter(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetProgramSubjectFilterMutationResult = NonNullable<
  Awaited<ReturnType<typeof getProgramSubjectFilter>>
>;

export type GetProgramSubjectFilterMutationError = unknown;

export const useGetProgramSubjectFilter = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getProgramSubjectFilter>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getProgramSubjectFilter>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getGetProgramSubjectFilterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getMyPastClassesByTimeline = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/api/v1/students/get/past-classes`, method: "POST", signal },
    options,
  );
};

export const getGetMyPastClassesByTimelineMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getMyPastClassesByTimeline>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getMyPastClassesByTimeline>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["getMyPastClassesByTimeline"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getMyPastClassesByTimeline>>,
    void
  > = () => {
    return getMyPastClassesByTimeline(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetMyPastClassesByTimelineMutationResult = NonNullable<
  Awaited<ReturnType<typeof getMyPastClassesByTimeline>>
>;

export type GetMyPastClassesByTimelineMutationError = unknown;

export const useGetMyPastClassesByTimeline = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getMyPastClassesByTimeline>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getMyPastClassesByTimeline>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getGetMyPastClassesByTimelineMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getPastClassesByTimeline = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/v1/students/get/timeline-past-classes`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getGetPastClassesByTimelineMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPastClassesByTimeline>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getPastClassesByTimeline>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["getPastClassesByTimeline"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getPastClassesByTimeline>>,
    void
  > = () => {
    return getPastClassesByTimeline(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetPastClassesByTimelineMutationResult = NonNullable<
  Awaited<ReturnType<typeof getPastClassesByTimeline>>
>;

export type GetPastClassesByTimelineMutationError = unknown;

export const useGetPastClassesByTimeline = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getPastClassesByTimeline>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getPastClassesByTimeline>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getGetPastClassesByTimelineMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getUpcomingOngoingClassesByTimeline = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/v1/students/get/timeline-ongoing-upcoming-classes`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getGetUpcomingOngoingClassesByTimelineMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getUpcomingOngoingClassesByTimeline>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getUpcomingOngoingClassesByTimeline>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["getUpcomingOngoingClassesByTimeline"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getUpcomingOngoingClassesByTimeline>>,
    void
  > = () => {
    return getUpcomingOngoingClassesByTimeline(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetUpcomingOngoingClassesByTimelineMutationResult = NonNullable<
  Awaited<ReturnType<typeof getUpcomingOngoingClassesByTimeline>>
>;

export type GetUpcomingOngoingClassesByTimelineMutationError = unknown;

export const useGetUpcomingOngoingClassesByTimeline = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getUpcomingOngoingClassesByTimeline>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getUpcomingOngoingClassesByTimeline>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getGetUpcomingOngoingClassesByTimelineMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
